var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('promo-offer-discount-line',{attrs:{"type":_vm.offerType,"description":_vm.discount.description,"amount":_vm.amount,"amount-is-hidden":_vm.amountHidden}})
}
var staticRenderFns = []

export { render, staticRenderFns }